const ADDON_FILTER = '-tag:addon';

const getSearchPath = () => {
  const url = window.Theme?.routes?.search_url ?? '/search';
  return url.replace(/\/$/, '');
};

export const appendAddonFilter = (value) => {
  const trimmed = (value ?? '').trim();
  if (!trimmed) return trimmed;
  if (trimmed.includes(ADDON_FILTER)) return trimmed;
  return `${trimmed} ${ADDON_FILTER}`;
};

const isSearchForm = (form) => {
  if (!(form instanceof HTMLFormElement)) return false;
  try {
    const action = new URL(form.action, window.location.origin);
    return action.pathname.replace(/\/$/, '') === getSearchPath();
  } catch {
    return false;
  }
};

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!isSearchForm(form)) return;
    const qInput = form.querySelector('input[name="q"]');
    if (!(qInput instanceof HTMLInputElement)) return;
    qInput.value = appendAddonFilter(qInput.value);
  },
  true
);
